import { deleteCookie } from 'cookies-next/client';

import { COMBINED_FLOW_LAYOUT } from '@/constants/cookies';
import { isServerCheck } from '@/modules/env/isServerCheck';

export async function clearCombinedFlowCookie() {
  if (isServerCheck()) {
    const { cookies } = await import('next/headers');
    (await cookies()).delete({ name: COMBINED_FLOW_LAYOUT, secure: true });
    return;
  }

  deleteCookie(COMBINED_FLOW_LAYOUT, { path: '/' });
}
